<style scoped>
@import "https://fonts.googleapis.com/icon?family=Material+Icons";
@import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";

::placeholder {
  color: #fff !important;
  opacity: 1; /* Firefox */
}
.logo-placeholder {
  box-shadow: none !important;
}

.sshi-logo {
  padding: 0.5rem;
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
}
.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}
.sshi-logo2 {
  margin: 0.25rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-logo3 {
  margin-left: 4rem;
  margin-right: 4rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-banner {
  margin-bottom: 0px;
  padding-top: 5em;
  background-image: url("/img/sshi/bg-scenery.webp");
  text-align: center;
  min-height: 35em;
}
.sshi-text {
  color: #fff !important;
}
.yellow-line {
  margin-left: 30%;
  margin-right: 30%;
  background-color: #ffdf12;
  height: 5px;
  border-radius: 20px;
}
.slide-root {
  margin-top: -11em;
  padding-left: 6em;
  padding-right: 6em;
}
.slide-bag {
  border-radius: 1em;
  padding-left: 1em;
  padding-right: 1em;
  padding-top: 3em;
  padding-bottom: 3em;
  background-color: white;
  color: rgb(0, 60, 128);
}
.slide-arrow {
  background-color: #ffff;
  border-radius: 100%;
  padding-top: 1.2em;
  padding-bottom: 2.2em;
  margin-left: -1.5em;
  margin-right: -1.5em;
  color: rgb(0, 147, 221);
}
.row_content ::before ::after {
  box-sizing: content-box;
}
.crop-image {
  width: 250px; /* Pastikan gambar memenuhi ukuran elemen */
  height: 200px; /* Atur tinggi sesuai kebutuhan */
  object-fit: cover; /* Crop gambar agar sesuai ukuran elemen */
  overflow: hidden; /* Sembunyikan bagian gambar yang keluar */
}
</style>
<template>
  <b-container
    fluid
    style="
      width: 100%;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
      padding-left: 0px;
      padding-right: 0px;
    "
  >
    <b-jumbotron class="sshi-banner text-center">
      <h1 class="sshi-text">Sistem Statistik Hayati Indonesia</h1>
      <div class="yellow-line"></div>
      <p style="color: white; margin-top: 2em">
        Kolaborasi antar Kementerian/Lembaga didukung oleh mitra pembangunan
        Indonesia
      </p>
      <div class="d-flex justify-content-center">
        <div class="sshi-logo2">
          <b-img
            class="sshi-logo"
            src="img/sshi/bps.png"
            alt="Badan Pusat Statistik"
          ></b-img>
        </div>
        <div class="sshi-logo2">
          <b-img
            class="sshi-logo"
            src="img/sshi/kemendagri.png"
            alt="Badan Pusat Statistik"
          ></b-img>
        </div>
        <div class="sshi-logo2">
          <b-img
            class="sshi-logo"
            src="img/sshi/kemenppn.png"
            alt="Badan Pusat Statistik"
          ></b-img>
        </div>
        <div class="sshi-logo2">
          <b-img
            class="sshi-logo"
            src="img/sshi/kemenkes.png"
            alt="Badan Pusat Statistik"
          ></b-img>
        </div>
      </div>
    </b-jumbotron>
    <vueper-slides
      class="slide-root no-shadow"
      :visible-slides="5"
      slide-multiple
      prevent-y-scroll
      :gap="2"
      :arrow="true"
      :bullets="false"
      :slide-ratio="1 / 5"
      :arrowsOutside="true"
      :dragging-distance="10"
    >
      <template #arrow-left>
        <b-icon class="slide-arrow" icon="chevron-compact-left"></b-icon>
      </template>
      <template #arrow-right>
        <b-icon class="slide-arrow" icon="chevron-compact-right"></b-icon>
      </template>
      <vueper-slide
        v-for="item in this.slideData"
        :key="item.id"
        :title="item.title"
        :content="item.content"
        :description="item.description"
        class="slide-bag"
      />
    </vueper-slides>
    <b-row class="ml-5 mr-5 mt-2 mb-0">
      <b-col class="ml-4 mr-5" style="text-align: center">
        <p><strong>Keterangan:</strong></p>
        <p>
          Estimasi kelengkapan registrasi kelahiran/kematian hingga cut-off date
          (Maret 2024) adalah jumlah peristiwa tahun (t) yang teregistrasi oleh
          sistem pencatatan sipil (pembilang) hingga batas cut-off date dibagi
          dengan estimasi jumlah peristiwa ‘sebenarnya’ (penyebut) tahun (t).
          Misalnya, estimasi kelengkapan sebesar 98%, artinya diperkirakan
          sebesar 98 persen kelahiran/kematian telah teregistrasi hingga batas
          waktu tersebut.
        </p>
      </b-col></b-row
    >
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5" style="text-align: center">
        <h2>SSHI: Pondasi Data Akurat untuk Masa Depan Indonesia</h2>
      </b-col>
    </b-row>
    <b-row class="ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <div
          style="
            background-color: white;
            padding: 4em;
            border-radius: 1em;
            text-align: justify;
          "
        >
          <p>
            Sistem Statistik Hayati Indonesia (SSHI) adalah sebuah platform yang
            dibangun oleh Badan Pusat Statistik bekerja sama dengan Direktorat
            Jenderal Kependudukan dan Pencatatan Sipil, Kementrian Kesehatan,
            dan Kementerian Perencanaan Pembangunan Nasional/Bappenas untuk
            menyediakan statistik hayati berdasarkan pencatatan sipil di
            Indonesia. Statistik ini mencakup peristiwa penting dalam kehidupan,
            seperti kelahiran, kematian, pernikahan, perceraian, dan adopsi.
            Pada tahun ini, Indonesia fokus pada pencatatan kelahiran dan
            kematian, dua komponen penting yang menjadi landasan kebijakan
            pemerintah dalam perencanaan dan penganggaran di tingkat pusat dan
            daerah.
          </p>
          <p>
            Melalui Platform SSHI, Anda dapat memahami secara menyeluruh
            peristiwa-peristiwa penting yang teregistrasi di seluruh Indonesia.
            Data yang dihasilkan dari platform ini mendukung pembangunan
            berkelanjutan serta pembuatan kebijakan yang lebih baik dan berbasis
            bukti.
          </p>
          <a href="/sshi/tentang">Selengkapnya</a>
        </div>
      </b-col>
    </b-row>

    <b-row class="ml-5 mr-5" style="padding-left: 10px; padding-right: 10px">
      <b-col
        class="ml-5 mr-5"
        style="
          background-image: url('img/sshi/bg3.jpg');
          background-size: contain;
          border-radius: 1em;
          border-top-left-radius: 10em;
          border-bottom-right-radius: 10em;
          margin-top: 2em;
          min-height: 70vh;
          color: white;
          text-align: center;
        "
        ><b-row class="mt-5 pb-5">
          <b-col cols="6">
            <b-row class="row_content">
              <h3 class="pl-5 pr-5">
                LAPORAN STATISTIK HAYATI INDONESIA 2019-2023
              </h3>
              <b-col cols="2"></b-col>
              <b-col cols="5">
                <b-img
                  style="height: 40em; margin-bottom: 4em; border-radius: 1em"
                  src="img/sshi/cover.jpg"
                  alt="Bayi"
                >
                </b-img>
              </b-col>
            </b-row>
            <a
              style="border-radius: 5px !important"
              class="btn btn-primary"
              type="submit"
              target="_blank"
              href="https://www.bps.go.id/id/publication/2024/10/17/f3eaad9790e201d758f8b34c/laporan-statistik-hayati-indonesia-2019-2023.html"
            >
              Lihat Publikasi
            </a>
          </b-col>
          <b-col cols="6">
            <b-row class="row_content">
              <h3 class="pl-5 pr-5" style="margin-bottom: 0px !important">
                MENUJU INKLUSIVITAS: PERKEMBANGAN PENCATATAN SIPIL DI INDONESIA
                2019-2023
              </h3>
              <b-col cols="2"></b-col>
              <b-col cols="4">
                <b-img
                  style="height: 40em; margin-bottom: 4em; border-radius: 1em"
                  src="img/sshi/menuju-inklusivitas.webp"
                  alt="Bayi"
                >
                </b-img>
              </b-col>
            </b-row>
            <a
              style="border-radius: 5px !important"
              class="btn btn-primary"
              type="submit"
              target="_blank"
              href="https://www.bps.go.id/id/publication/2024/12/20/216170cff87601ed5864acdf/menuju-inklusivitas-perkembangan-pencatatan-sipil-di-indonesia-2019-2023.html"
            >
              Lihat Publikasi
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5" style="text-align: left">
        <h2>Berita Kegiatan SSHI</h2>
      </b-col>
      <b-col style="text-align: right">
        <b-button
          href="#"
          @click.prevent="goToNews"
          style="color: rgb(0, 60, 128); font-size: 1rem !important"
          variant="link"
          class="text-decoration-none align-items-center"
        >
          Lihat Semua
          <b-icon icon="arrow-right" style="cursor: pointer"></b-icon>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="ml-5 mr-5 mb-0">
      <b-col class="pl-5 pr-5" cols="12">
        <b-row>
          <b-col v-if="isNewsLoading">
            <b-skeleton animation="wave" width="85%"></b-skeleton>
            <b-skeleton animation="wave" width="85%"></b-skeleton>
            <b-skeleton animation="wave" width="85%"></b-skeleton>
            <b-skeleton animation="wave" width="55%"></b-skeleton>
            <b-skeleton animation="wave" width="55%"></b-skeleton>
          </b-col>
          <b-col v-else v-for="item in news" :key="item.id" cols="3">
            <b-card
              class="mb-4 pl-0 pr-0 shadow-none clickable"
              style="min-height: 450px"
              @click="onRowClick(item.slug)"
            >
              <b-img
                class="crop-image"
                fluid
                :src="getBase64Image(item.thumbnail)"
                alt="Left image"
              ></b-img>
              <p style="font-weight: 400; margin-bottom: 0px; margin-top: 2%">
                {{ item.formattedDate }}
                <b-badge v-if="item.isDone" variant="primary"
                  >Telah Dilaksanakan</b-badge
                >
                <b-badge v-else variant="success">Akan Datang</b-badge>
              </p>
              <p style="font-weight: 600; font-size: 1.2rem">
                {{ item.title }}
              </p>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5" style="text-align: center">
        <h2>Data Bercerita</h2>
      </b-col>
    </b-row>

    <b-row class="ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <div
          style="
            background-color: white;
            border-radius: 1em;
            text-align: justify;
            margin-top: 4em;
            margin-left: 2em;
          "
        >
          <b-row>
            <b-col>
              <b-img
                fluid
                style="
                  border-radius: 1em;
                  border-top-left-radius: 7em;
                  border-bottom-right-radius: 7em;
                  z-index: 2;
                  position: relative;
                  top: -10%;
                  left: -2em;
                "
                src="img/sshi/baby.jpg"
                alt="Bayi"
              >
              </b-img>
            </b-col>
            <b-col style="padding: 2em 4em 4em 1em">
              <h5>Peningkatan Kualitas Registrasi Kelahiran di Indonesia</h5>
              <p>
                Di Indonesia, kemajuan dalam registrasi kelahiran semakin
                terlihat. Estimasi kelengkapan registrasi kelahiran secara umum
                meningkat sepanjang 2019 hingga 2023. Estimasi kelengkapan
                berdasarkan periode waktu yang diwajibkan (maksimal 60 hari
                setelah kelahiran) meningkat dari 34 hingga 41 persen sepanjang
                2019-2023. Estimasi kelengkapan tahun 0 cenderung berada di
                kisaran 50 persen. Sementara itu, estimasi kelengkapan
                berdasarkan tahun kejadian untuk 2019 telah mencapai 94,32
                persen dan tahun 2023 telah mencapai 62,11 persen. Dari sisi
                kewilayahan, Provinsi DKI Jakarta memimpin dengan kelengkapan
                registrasi, estimasi kelengkapan registrasi berdasarkan tahun
                kejadian telah mencapai 86,07 persen.
              </p>
              <p class="mt-3">
                <strong
                  ><i
                    >Mari bersama-sama pastikan setiap kelahiran tercatat!
                    Kualitas data kelahiran adalah kunci untuk perencanaan yang
                    lebih baik!</i
                  ></strong
                >
              </p>
            </b-col>
          </b-row>
        </div>

        <div
          style="
            background-color: white;
            border-radius: 1em;
            text-align: justify;
            margin-top: 4em;
            margin-left: 2em;
          "
        >
          <b-row>
            <b-col>
              <b-img
                fluid
                style="
                  border-radius: 1em;
                  border-top-left-radius: 7em;
                  border-bottom-right-radius: 7em;
                  z-index: 2;
                  position: relative;
                  top: -10%;
                  left: -2em;
                "
                src="img/sshi/kematian_foto.jpg"
                alt="Bayi"
              >
              </b-img>
            </b-col>
            <b-col style="padding: 2em 4em 4em 1em">
              <h5>
                Meningkatkan Pelaporan Kematian: Data yang Menyelamatkan Nyawa!
              </h5>
              <p>
                Pelaporan kematian di Indonesia juga menunjukkan perbaikan
                signifikan! Dari tahun 2019–2020, pelaporan tahun 0 berada di
                kisaran 34–37%, namun meningkat menjadi 50–59% pada tahun
                2021–2023. Tahun 2021 mencetak rekor dengan tingkat kelengkapan
                mencapai 92,30%, didorong oleh peningkatan perhatian terhadap
                kesehatan masyarakat selama pandemi.
              </p>
              <p class="mt-3">
                <i
                  ><strong
                    >Kelengkapan data kematian sangat penting! Setiap laporan
                    membantu meningkatkan layanan kesehatan dan keselamatan
                    masyarakat!</strong
                  ></i
                >
              </p>
            </b-col>
          </b-row>
        </div>

        <b-row style="margin-top: 2em">
          <b-col style="text-align: center"
            ><h2>Telusuri data lainnya</h2></b-col
          >
        </b-row>

        <!-- Baris 1 -->
        <div class="d-flex justify-content-center" style="margin-bottom: 2em">
          <div class="sshi-logo3">
            <div class="d-flex flex-column">
              <a
                href="/sshi/katalog-data?kategori=capaian-akpsh"
                style="color: black !important; font-weight: 400"
              >
                <div class="d-flex justify-content-center">
                  <b-img
                    class="sshi-logo"
                    src="img/sshi/administrasi.png"
                    alt="Badan Pusat Statistik"
                    style="max-width: 120px"
                  >
                  </b-img>
                </div>
                <div style="text-align: center">Capaian AKPSH</div>
              </a>
            </div>
          </div>
          <div class="sshi-logo3">
            <div class="d-flex flex-column">
              <a
                href="/sshi/katalog-data?kategori=struktur-penduduk"
                style="color: black !important; font-weight: 400"
              >
                <div class="d-flex justify-content-center">
                  <b-img
                    class="sshi-logo"
                    src="img/sshi/struktur.png"
                    alt="Badan Pusat Statistik"
                  >
                  </b-img>
                </div>
                <div style="text-align: center">Penduduk</div>
              </a>
            </div>
          </div>

          <div class="sshi-logo3">
            <div class="d-flex flex-column">
              <a
                href="/sshi/katalog-data?kategori=kelahiran"
                style="color: black !important; font-weight: 400"
              >
                <div class="d-flex justify-content-center">
                  <b-img
                    class="sshi-logo"
                    src="img/sshi/kelahiran.png"
                    alt="Badan Pusat Statistik"
                    style="max-width: 100px"
                  >
                  </b-img>
                </div>
                <div style="text-align: center">Kelahiran</div>
              </a>
            </div>
          </div>

          <div class="sshi-logo3">
            <div class="d-flex flex-column">
              <a
                href="/sshi/katalog-data?kategori=kematian"
                style="color: black !important; font-weight: 400"
              >
                <div class="d-flex justify-content-center">
                  <b-img
                    class="sshi-logo"
                    src="img/sshi/kematian.png"
                    alt="Badan Pusat Statistik"
                  >
                  </b-img>
                </div>
                <div style="text-align: center">Kematian</div>
              </a>
            </div>
          </div>
          <div class="sshi-logo3">
            <div class="d-flex flex-column">
              <a
                href="/sshi/katalog-data/kesehatan"
                style="color: black !important; font-weight: 400"
              >
                <div class="d-flex justify-content-center">
                  <b-img
                    class="sshi-logo"
                    src="img/sshi/kesehatan.png"
                    alt="Badan Pusat Statistik"
                  >
                  </b-img>
                </div>
                <div style="text-align: center">Kesehatan</div>
              </a>
            </div>
          </div>
        </div>

        <!-- Baris 2 -->
        <div class="d-flex justify-content-center"></div>
        <!-- </div>   -->
      </b-col>
    </b-row>

    <!-- <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5">
        <h2>PUBLIKASI DAN DASAR HUKUM</h2>
      </b-col>
    </b-row>
    <b-row class="ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <vueper-slides
          class="no-shadow"
          :visible-slides="5"
          prevent-y-scroll
          :gap="2"
          :arrow="true"
          :bullets="false"
          :slide-ratio="1 / 5"
          :arrowsOutside="true"
          :dragging-distance="10"
        >
          <vueper-slide
            @click.native="openLink(item.url)"
            v-for="item in this.slidePublikasi"
            :key="item.id"
            :title="item.title"
            :content="item.content"
            :description="item.description"
            :image="item.image"
            class="slide-bag"
          /> </vueper-slides
      ></b-col>
    </b-row> -->
  </b-container>
</template>
<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import sdiService from "../../../services/SdiService";
export default {
  name: "sshi-index",
  data() {
    return {
      ceklogin: false,
      news: [],
      isNewsLoading: true,
      slideData: [
        {
          id: 1,
          title:
            '<span class="material-symbols-outlined" style="color: rgb(0, 147, 221); font-size: 30pt;">breastfeeding</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Kelengkapan Registrasi Kelahiran sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">94,32%</h2><p style="font-size:1.5rem;font-weight: 500;">2019</p>',
        },
        {
          id: 2,
          title:
            '<span class="material-symbols-outlined" style="color: rgb(0, 147, 221); font-size: 30pt;">breastfeeding</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Kelengkapan Registrasi Kelahiran sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">91,36%</h2><p style="font-size:1.5rem;font-weight: 500;">2020</p>',
        },
        {
          id: 3,
          title:
            '<span class="material-symbols-outlined" style="color: rgb(0, 147, 221); font-size: 30pt;">breastfeeding</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Kelengkapan Registrasi Kelahiran sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">85,01%</h2><p style="font-size:1.5rem;font-weight: 500;">2021</p>',
        },
        {
          id: 4,
          title:
            '<span class="material-symbols-outlined" style="color: rgb(0, 147, 221); font-size: 30pt;">breastfeeding</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Kelengkapan Registrasi Kelahiran sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">75,49%</h2><p style="font-size:1.5rem;font-weight: 500;">2022</p>',
        },
        {
          id: 5,
          title:
            '<span class="material-symbols-outlined" style="color: rgb(0, 147, 221); font-size: 30pt;">breastfeeding</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Kelengkapan Registrasi Kelahiran sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">62,11%</h2><p style="font-size:1.5rem;font-weight: 500;">2023</p>',
        },
        {
          id: 6,
          title:
            '<span class="material-icons" style="color: rgb(0, 147, 221); font-size: 40pt;">groups</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Perkembangan Registrasi Kematian sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">64,11%</h2><p style="font-size:1.5rem;font-weight: 500;">2019</p>',
        },
        {
          id: 7,
          title:
            '<span class="material-icons" style="color: rgb(0, 147, 221); font-size: 40pt;">groups</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Perkembangan Registrasi Kematian sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">68,50%</h2><p style="font-size:1.5rem;font-weight: 500;">2020</p>',
        },
        {
          id: 8,
          title:
            '<span class="material-icons" style="color: rgb(0, 147, 221); font-size: 40pt;">groups</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Perkembangan Registrasi Kematian sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">92,30%</h2><p style="font-size:1.5rem;font-weight: 500;">2021</p>',
        },
        {
          id: 9,
          title:
            '<span class="material-icons" style="color: rgb(0, 147, 221); font-size: 40pt;">groups</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Perkembangan Registrasi Kematian sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">69,16%</h2><p style="font-size:1.5rem;font-weight: 500;">2022</p>',
        },
        {
          id: 10,
          title:
            '<span class="material-icons" style="color: rgb(0, 147, 221); font-size: 40pt;">groups</span>',
          content:
            '<h6 style="color:#003C80!important;margin-bottom:1em !important">Estimasi Perkembangan Registrasi Kematian sampai dengan Cut-Off Date*</h6><h2 style="margin-bottom:0px!Important">60,91%</h2><p style="font-size:1.5rem;font-weight: 500;">2023</p>',
        },
      ],
      slidePublikasi: [
        {
          id: 1,
          image:
            "https://www.bps.go.id/_next/image?url=https%3A%2F%2Fwebapi.bps.go.id%2Fcover.php%3Ff%3DwUDdFhgsnhVZSJtHCBMZP2FuUVRES0JtMTgrczh5N1UxTXdIVC9EbUE0Vzg3aHNjK3Y0SFZBZjhwUEhQY0pQZ0NERXZ3OU5FMUxOaWd5cEtwSE93eURGdkZvQkFueWhsMXhYb1ZtcnpWWnhCN3NrclZFaEt4TEM0U2tVR0RlNXJXQXlIbUZiSFdPdnBoYkh6&w=3840&q=75",
          url: "https://www.bps.go.id/id/publication/2024/02/02/f1e801ce263e5d1520375f59/mortalitas-di-indonesia-hasil-long-form-sensus-penduduk-2020.html",
        },
        {
          id: 2,
          image:
            "https://www.bps.go.id/_next/image?url=https%3A%2F%2Fwebapi.bps.go.id%2Fcover.php%3Ff%3DogjiPbkHlEvTlupvStEArk0yVXNNT2s3NTVKYzRQWDZ4eXRob01LVTJUeUErc3l6akRIZ0ZtNmU2bXpvdXVYRHRoa3c1MjY4S3N1OVJyQlJEWkxPME55WDF6V1lveHRPUGlqWEpSU01CeWRRWUJtYW43MmJlZDYwb2FJZVVVUmxDVjlKY0RYdXdsclpHTWZz&w=3840&q=75",
          url: "https://www.bps.go.id/id/publication/2023/09/28/f9d33e0982c5b537b4af7483/buku-i-analisis-tematik-kependudukan-indonesia--fertilitas-remaja--kematian-maternal--kematian-bayi--dan-penyandang-disabilitas-.html",
        },
        {
          id: 3,
          image:
            "https://www.bps.go.id/_next/image?url=https%3A%2F%2Fwebapi.bps.go.id%2Fcover.php%3Ff%3DOh%2FiEpy8nGqMxL%2BL%2BDOr2GFjcktMV3dlRjAwY3FXZ3pOWW14b09Yc2lpaTBLWkZDcEFESVVZYldnM0ZhV1ptdzNuTUhpWjcwZTYzUisxWG9HTVZSeExhSWlqZWUvZEUyK29mb0lGbWpYRTVvNVdYQzRHZUZqekhDellGd3c1Z0M2T2RJMjBXbmw0US84Zk9v&w=3840&q=75",
          url: "https://www.bps.go.id/id/publication/2023/12/29/5d308763ac29278dd5860fad/statistik-penduduk-lanjut-usia-2023.html",
        },
        {
          id: 4,
          image:
            "https://www.bps.go.id/_next/image?url=https%3A%2F%2Fwebapi.bps.go.id%2Fcover.php%3Ff%3DrQeDrk15yZ%2FeeHVipZP7Q3lENFdXRC9UTUdkMGhwblFsdGNOam5ON0NaTCtsRUppTHlBMk1ZbkFQdFdjMzhEZWtFK3lrcTZhLy9sd3hWam5kYldOOEdUU2JiMVlwVm8zN2dTT1hsUDBOak1LKzlBTEVhcWFzMlFFNmg4R3JrRjF3QUJ5MjNDcDlacWRNOUNr&w=3840&q=75",
          url: "https://www.bps.go.id/id/publication/2023/12/22/82a2bd337ba802ac19611b71/statistik-mobilitas-penduduk-dan-tenaga-kerja-2023.html",
        },
        {
          id: 5,
          image:
            "https://www.bps.go.id/_next/image?url=https%3A%2F%2Fwebapi.bps.go.id%2Fcover.php%3Ff%3DYvDUEWfZDcvR8YrNey71E0wxMlA4TzJOLzlwK1NWdmpVME5MeXRnTFM4a0ZvVEc1NlA1UUZPT3Jrc3NaeWVYVExkOTlEaFZMR3hZTjZqSDl0QmdqZUk1dkFzeHV0RWE3aGV0L21Tc2tIcFc4ZWFkaWFGd1JwZFpSVjRMNHFyaU1kRldVaEdEaFF1UHJ6QjNH&w=3840&q=75",
          url: "https://www.bps.go.id/id/publication/2023/12/22/7c6f371f7156b1230377fc96/dokumentasi-komprehensif-sensus-penduduk-2020.html",
        },
        {
          id: 6,
          image:
            "https://www.bps.go.id/_next/image?url=https%3A%2F%2Fwebapi.bps.go.id%2Fcover.php%3Ff%3Dzv6kFWdB2E5E9Pg1or8NXHUwUmVKRWtkY3hKaDR1bzhBR2t6c1Yzdi95cmpCcTF0WXpaUkxqTVF3MTlUcC9LMS9CRmZyb1RLNFQ0Y1gyZnBFbG14L1VucHMwSUdEcXZpNnlSdytNTlJIKzdjaytTUXcrYXhIOWNIT2pDS24wR2ZLajhaZExpV05sTS9zZnZz&w=3840&q=75",
          url: "https://www.bps.go.id/id/publication/2023/09/28/e963fbb4c91c404de65f4bfc/buku-iii-analisis-tematik-kependudukan-indonesia--pembangunan-manusia-dan-pembangunan-wilayah-.html",
        },
      ],
    };
  },
  components: { VueperSlides, VueperSlide },
  created() {},
  mounted() {
    this.loadNews();
    this.cekLogin();
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  methods: {
    onRowClick(item) {
      this.$router.push("/sshi/news/" + item);
      window.scrollTo(0, 0);
    },
    goToNews() {
      this.$router.push("/sshi/news");
    },
    getBase64Image(base64) {
      // Menambahkan awalan data:image/jpeg;base64, jika Base64 tidak mengandung awalan
      const mimeType = this.getMimeType(base64);
      const fullBase64 = `data:${mimeType};base64,${base64}`;
      return fullBase64;
    },
    getMimeType(base64) {
      // Cek tipe MIME dari Base64 string, bisa dikembangkan lebih lanjut
      if (base64.startsWith("iVBOR")) {
        return "image/png"; // Jika Base64 string diawali dengan 'iVBOR' berarti PNG
      } else if (base64.startsWith("/9j/")) {
        return "image/jpeg"; // Jika Base64 string diawali dengan '/9j/' berarti JPEG
      }
      return "image/jpeg"; // Default ke JPEG jika tidak diketahui
    },
    async loadNews() {
      await sdiService.getNews(0, 4, "sshi", "").then(
        (response) => {
          this.totalElements = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.news = response.data.content;
          this.news = this.news.map((item) => {
            return {
              ...item,
              isDone: new Date() > new Date(item.doneAt) ? true : false,
              formattedDate: new Intl.DateTimeFormat("id-ID", {
                day: "numeric",
                month: "long",
                year: "numeric",
              }).format(new Date(item.postAt)),
              preview:
                item.content
                  .slice(0, 500)
                  .replace("</p>", "")
                  .replace("<br>", "")
                  .replace("<p>", "")
                  .replace("<p></p>", "") + "...",
            }; // Contoh logika untuk 'age'
          });
          this.isNewsLoading = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    openLink(url) {
      window.open(url, "_blank").focus();
    },
    cekLogin() {
      let status = JSON.parse(localStorage.getItem("vuex"));
      if (status.auth.status == 0 || status == "") {
        this.ceklogin = true;
      }
      console.log(status);
    },
    keLogin() {
      window.location.href = "/login";
    },
  },
};
</script>

